module.exports = {
  title: 'Image Cropper with React Native Skia 🖼️',
  author: 'Enzo Manuel Mangano',
  date: '2023-06-19',
  slug: 'image-cropper',
  tags: ['skia', 'gesture-handler'],
};
